import classNames from 'classnames'

import './Form.scss'

interface FormProps {
  className?: string
  onSubmit?: () => void
  children?: React.ReactNode
}

export const Form: React.FC<FormProps> = ({
  onSubmit,
  className,
  children,
}) => {
  return (
    <form className={classNames('form', className)} onSubmit={onSubmit}>
      {children}
    </form>
  )
}
